import Cookies from 'js-cookie'

document.addEventListener('DOMContentLoaded', () => {
    let viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    let viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    const newsletter = document.querySelector('.site-footer');

    const hamburger = document.querySelector('.hamburger');
    hamburger.addEventListener('click', ({ event }) => {
        hamburger.classList.toggle('is-active');
        document.querySelector('body').classList.toggle('menu-is-open');
    });




    // newsletter popup
    const newsletterBanner = document.querySelector('.site-footer__newsletter');
    const newsletterClick = document.querySelector('.site-footer__newsletter-banner');

    newsletterClick.addEventListener('click', (event) => {
        newsletterBanner.classList.toggle('is-open');
    });

    const dismissNewsletter = document.querySelector('.newsletter-close');
    dismissNewsletter.addEventListener('click', (event) => {
        Cookies.set('closed-newsletter', 'true');
        newsletterBanner.classList.add('discarded');
        newsletter.classList.add('no-newsletter');
        event.stopPropagation();
    });

    let newsletterCookie = Cookies.get('closed-newsletter');
    if (newsletterCookie) {
        newsletter.classList.add('no-newsletter');
        newsletterBanner.classList.add('discarded');
    }

    [...document.querySelectorAll('.menu-item-has-children')].map(el => {
        el.addEventListener('click', (event) => {
            if (!event.target.classList.contains('menu-item-has-children')) return;
            if (event.currentTarget !== '') el.classList.toggle('is-open');
        })
    });

    const menuItems = document.querySelectorAll('.menu a');
    for (let i = 0; i < menuItems.length; i++) {
        const menuItem = menuItems[i];

        // on focus of link with a dropdown menu, add hover class. 
        menuItem.addEventListener('focusin', (event) => {
            const li = event.currentTarget.closest('.menu-item-has-children');
            if (li) {
                li.classList.add('hover');
            } else {
                const dropDowns = document.querySelectorAll('.menu-item-has-children');
                for (let j = 0; j < dropDowns.length; j++) {
                    const dropDown = dropDowns[j];
                    dropDown.classList.remove('hover');
                }
            }
        });

        // on focus out we check if not focused on anything and close any dropdowns
        document.addEventListener('focusout', (event) => {
            if (event.relatedTarget === null) {
                const dropDowns = document.querySelectorAll('.menu-item-has-children');
                for (let j = 0; j < dropDowns.length; j++) {
                    const dropDown = dropDowns[j];
                    dropDown.classList.remove('hover');
                }
            }
        });
    }


    // [...document.querySelectorAll('.menu-item-has-children > a')].map(el => {
    //     el.addEventListener('click', (event) => {
    //         event.preventDefault();

    //         event.currentTarget.classList.toggle('is-open');
    //     });
    // });




    // mobile filters on change
    const mobileFilters = document.querySelector('.js-filter');
    if (mobileFilters) {
        mobileFilters.addEventListener('change', function(e) {
            let form = this.closest(".mobile-filters");
            console.log(form);
            form.action = this.value;
            form.submit();
            console.log(this.value);
        });
    }


    //share popups
    [...document.querySelectorAll('.popup-link')].map(el => {
        el.addEventListener('click', (event) => {
            event.preventDefault();
            viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

            var width = 575,
                height = 400,
                left = (viewportWidth - width) / 2,
                top = (viewportHeight - height) / 2,
                url = event.currentTarget.href,
                opts = 'status=1' +
                ',width=' + width +
                ',height=' + height +
                ',top=' + top +
                ',left=' + left;
            window.open(url, 'share', opts);
        });
    });

    // smooth scroll links
    const scrollLinks = document.querySelectorAll('.scroll-link');

    for (const link of scrollLinks) {
        link.addEventListener('click', scrollClickHandler);
    }

    function scrollClickHandler(e) {
        e.preventDefault();
        const href = this.getAttribute('href');
        let contentOffset = 86;
        if (viewportWidth > 1020) contentOffset = 120;
        if (viewportWidth >= 1200) contentOffset = 140;
        const offsetTop = document.querySelector(href).offsetTop - contentOffset;

        scroll({
            top: offsetTop,
            behavior: 'smooth'
        });
    }

    // on scroll change appearance of site header
    var scrollObject = {};
    window.onscroll = getScrollPosition;

    function getScrollPosition() {
        scrollObject = {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
        // If you want to check distance
        if (scrollObject.y > 0) {
            document.querySelector('.site-header').classList.add('has-scrolled');
        } else {
            document.querySelector('.site-header').classList.remove('has-scrolled');
        }
    }

    window.addEventListener('resize', resizeWindow);
    // On window resize make sure menus fit on screen
    function resizeWindow() {
        viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
        if (viewportWidth < 1020) {
            document.querySelector('.main-nav').style.height = viewportHeight + "px";
        } else {
            document.querySelector('.main-nav').removeAttribute('style');
        }
    }
    resizeWindow();
});